import CloseIcon from '@/app/icons/close'
import { IUser } from '@giphy/js-types'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import useLocalStorage from 'react-use/lib/useLocalStorage'
import { desktopWidth } from 'ui/src/constants'
import Avatar from '../../avatar'
import { AccessProps } from './channel-access-menu'

const ChannelAccessFooter = ({ user }: AccessProps) => {
    const { channel_access } = user
    const firstUser = channel_access?.user || user
    const [hasClosedBanner, setHasClosedBanner] = useLocalStorage(`has-closed-access-banner ${user.id}`, false)
    const [documentMounted, setDocumentMounted] = useState(false)

    useEffect(() => {
        setDocumentMounted(true)
    }, [])

    if (!documentMounted || !channel_access?.emulated_user?.id || hasClosedBanner) {
        return null
    }

    return createPortal(
        <footer className="fixed right-0 bottom-0 left-0 z-belowHeader flex h-[85px] content-center justify-between bg-giphyDarkGrey text-giphyLightGrey">
            <div className="m-auto flex w-full items-center px-4" style={{ maxWidth: `${desktopWidth}px` }}>
                <div className="mr-auto flex items-center gap-x-3">
                    {/* Avatar only reads avatar_url/username/profile_url (see
                    avatar.tsx) but declares a full IUser prop; channel_access's
                    real payload is the smaller AccessUser shape (matches
                    ListItem's own `Partial<IUser>` treatment of the same data
                    in channel-access-menu.tsx) — cast, not a shape mismatch. */}
                    <Avatar user={channel_access.emulated_user as unknown as IUser} size={32} />
                    <p>
                        Browsing as{' '}
                        <strong>{channel_access.emulated_user.display_name || channel_access.user?.username}</strong>
                    </p>
                </div>

                <div className="mr-16 flex items-center gap-x-5">
                    <a
                        href={`/api/v4/channels/access/logout`}
                        className="flex items-center gap-x-2 transition-colors hover:text-giphyWhite"
                    >
                        <span>Switch back to</span>
                        <Avatar user={firstUser as unknown as IUser} size={24} />
                        <span>{firstUser.display_name || firstUser.username}</span>
                    </a>

                    <button
                        onClick={() => setHasClosedBanner(true)}
                        className="transition-colors hover:text-giphyWhite"
                        aria-label="Close banner"
                    >
                        <CloseIcon width={20} height={20} />
                    </button>
                </div>
            </div>
        </footer>,
        document.body,
        'channel-access-footer'
    )
}

export default ChannelAccessFooter
